import React from 'react';
import { useMutation } from '@tanstack/react-query';
import Builder from './Builder';
import { AddonSheet } from '../../../models';
import useIndividualPrintOption from '../../../hooks/useIndividualPrintOption';
import useOption from '../../../hooks/useOption';
import usePackagePoses from '../../../hooks/usePackagePoses';
import useBackgrounds from '../../../hooks/useBackgrounds';

export default function IndividualPrintsBuilder({
  background,
  cartId,
  isElementary = true,
  onSave,
  optionId,
  orderPackage,
  packageId,
  pose,
  poses,
  schoolId,
  studentId,
  onCancelProps = {},
  useRetouching = false,
}) {
  // API Data
  const { data: individualPrintOption } = useIndividualPrintOption();
  const { data: option } = useOption(optionId, schoolId);
  const { data: packagePoses } = usePackagePoses(packageId);
  const { data: backgrounds } = useBackgrounds(packageId);

  const {
    mutate,
    isLoading,
  } = useMutation({
    mutationFn: ({ addonSheets, extras = [] }) => {
      // Destroy any sheets on the orderPackage (if any), and replace with the new sheets

      const oldSheets = orderPackage.addonSheets.map((sheet) => {
        sheet.isMarkedForDestruction = true;

        return sheet;
      });

      const newAddonSheets = addonSheets
        .map((sheetParams) => {
          if (sheetParams.addon.name === 'Digital File for ALL poses') {
            return poses.map((pose) => ({ ...sheetParams, pose, poseId: pose.id }));
          }

          return { ...sheetParams };
        })
        .flat()
        .map((sheetParams, i) => new AddonSheet({ ...sheetParams, i }));

      orderPackage.cartId = cartId;
      orderPackage.studentId = studentId;
      orderPackage.packageId = packageId;
      orderPackage.optionId = optionId ?? individualPrintOption.id;
      orderPackage.apiOption = optionId ? option : individualPrintOption;
      orderPackage.addonSheets = [...oldSheets, ...newAddonSheets];
      if (extras.length > 0) orderPackage.extras = extras;

      return orderPackage.save({ with: ['addonSheets', 'extras'] });
    },
    onSuccess: () => {
      if (Object.keys(orderPackage.errors).length > 0) return;

      onSave();
    },
  });

  return (
    <Builder
      useRetouching={useRetouching}
      packagePoses={packagePoses}
      background={background}
      backgrounds={backgrounds}
      isElementary={isElementary}
      orderPackage={orderPackage}
      pose={pose}
      onConfirm={(addonSheets, extras) => mutate({ addonSheets, extras })}
      isLoading={isLoading}
      onCancelProps={onCancelProps}
    />
  );
}
